import React, {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {Text, VStack} from '@chakra-ui/react'
import HybridLink from '../../../components/hybrid-link'
import {HYBRID_CUSTOMER_SERVICE} from '../../../constants'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import {normalizeSfccLink} from '../../../utils/url'

const CSQuickLinks = () => {
    const {formatMessage, locale} = useIntl()
    const {quicklinks} = useCustomerServicePageConfig()

    const normalizedQuicklinks = useMemo(
        () =>
            quicklinks?.map(({link, label}) => ({
                label,
                href: normalizeSfccLink(locale, link)
            })) ?? [],
        [quicklinks, locale]
    )

    if (!normalizedQuicklinks?.length) {
        return null
    }

    return (
        <VStack alignItems="center" data-testid="cs-quick-links">
            <Text textStyle="Regular 2XLarge" pb={{base: 8, md: 10}} pt={{base: 12, md: 20}}>
                {formatMessage({
                    id: 'cs.layout.quicklinks',
                    defaultMessage: 'Quicklinks'
                })}
            </Text>
            <VStack spacing={3} pb={28}>
                {normalizedQuicklinks.map((el) => (
                    <HybridLink key={el.label} page={HYBRID_CUSTOMER_SERVICE} to={el.href}>
                        {el.label}
                    </HybridLink>
                ))}
            </VStack>
        </VStack>
    )
}

export default CSQuickLinks
